import React from 'react'
import Link from 'gatsby-link'

import Header from '../components/Header'
import Footer from '../components/Footer'
import SectionLink from '../components/SectionLink'
import adminHomePage from '../assets/images/admin-home-page.png'

const sections = [
  {
    name: 'SOURCE+ precise and aggregated search',
    id: 'using-source',
    description:
    (
      <span>
        <p>SOURCE+ is an intelligent legal search engine that understands legal concepts and their relevance to Cases, Commentaries and Court Submissions*. It helps you find pertinent information quickly and efficiently across several Commonwealth jurisdictions.</p>
        <p>*Submissions from High Court of Australia will be available in the basic plan for a limited period with Legislation & Regulations coming soon.</p>
      </span>
    ),
    contents: [
      { name: 'SOURCE+ Content Coverage', path: '/source/source-coverage' },
      { name: 'Refine Your Search (Boolean Guide)', path: '/source/refine-your-search' },
    ],
  },
  {
    name: 'STACKS - knowledge library for your firm',
    id: 'using-stacks',
    description:
    (
      <span>
        <p>Tired of navigating through a maze of folders to find a previous precedent or earlier research? Forgot how you named your folder?</p>
        <p>STACKS is your law firm’s <b>knowledge library</b>, where your work documents and legal research from different sources such as personal precedents, search result links, submissions and office memorandums, can be consolidated and organised intelligently.</p>
        <p>Our AI technology automatically recommends <b>Categories</b> to classify your documents which are synced and uploaded to INTELLLEX according to their legal topic and document type. Get organised from the get-go, so that future retrieval will be a cinch.</p>
      </span>
    ),
    contents: [
      { name: 'Sync or Upload Your Folders and Files', path: '/stacks/sync-or-upload-your-folders-and-files' },
      { name: 'Organise your STACKS', path: '/stacks/organise-your-stacks' },
      { name: 'Search in STACKS', path: '/stacks/search-in-stacks' },
      { name: 'Share and Request for Access', path: '/stacks/share-and-request-for-access' },
    ],
  },
  {
    name: 'Workspace Administration',
    id: 'using-admin',
    description:
    (
      <span>
        <p>As a Workspace Admin, you are critical to the success of your organisation through effective management of your firm’s knowledge library and the optimal use of INTELLLEX.</p>
        <p>To assist you, we have built tools to help you manage user, Categories and view activity logs. Only Admins will have access to these features under the Admin section.</p>
      </span>
    ),
    contents: [
      { name: 'Categories Management', path: '/admin/categories-management' },
    ],
    thumbnail: adminHomePage,
  },
  {
    name: 'Contact Us',
    id: 'contact-us',
    contents: [],
  },
]

const ContentLint = ({ name, path }) => (
  <Link to={path}>{name}</Link>
)

const Section = ({ id, name, description, contents, thumbnail }) => (
  <div id={id} className="catalog-section-container">
    <h1>{name}</h1>
    <div className="description">{description}</div>
    {thumbnail && <div className="thumbnail">
      <img src={thumbnail} alt={name} />
    </div>}
    <div className="row">
      {contents.map(({ name, path }) =>
        <div className="col-12 col-md-6 content-link-container" key={path}>
          <ContentLint name={name} path={path} />
        </div>
      )}
    </div>
  </div>
)

const ContactUs = ({ id, name }) => (
  <div id={id} className="catalog-section-container">
    <h1>{name}</h1>
    <p>Experiencing an issue on INTELLLEX? Let us know how we can help.</p>
    <br />
    <a className="button blue-face" href="mailto:support@intelllex.com">Email us</a>
  </div>
)

const IndexPage = () => (
  <div>
    <Header tall />
    <div className="container main-page-container">
      <div className="row">
        <div className="col-12 col-md-3">
          {sections.map(({ name, id }) =>
            <SectionLink key={id} name={name} scrollTo={id} />
          )}
        </div>
        <div className="col-12 col-md-9" id="catalog-index">
          {sections.map(({ id, name, contents, description, thumbnail }) =>
            id !== 'contact-us'
              ? <Section key={id} id={id} name={name} contents={contents} description={description} thumbnail={thumbnail} />
              : <ContactUs key={id} id={id} name={name} />
          )}
        </div>
      </div>
    </div>
    <Footer />
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js